export const OPEN_WIDGET = 'OPEN_WIDGET';
export const CLOSE_WIDGET = 'CLOSE_WIDGET';
export const ENABLE_SETTINGS = 'ENABLE_SETTINGS';
export const DISABLE_SETTINGS = 'DISABLE_SETTINGS';
export const ENABLE_SOUND_NOTIFICATION = 'ENABLE_SOUND_NOTIFICATION';
export const DISABLE_SOUND_NOTIFICATION = 'DISABLE_SOUND_NOTIFICATION';
export const SHOW_UPLOAD = 'SHOW_UPLOAD';
export const HIDE_UPLOAD = 'HIDE_UPLOAD';
export const SHOW_SETTINGS = 'SHOW_SETTINGS';
export const HIDE_SETTINGS = 'HIDE_SETTINGS';
export const SHOW_CONNECT_NOTIFICATION = 'SHOW_CONNECT_NOTIFICATION';
export const HIDE_CONNECT_NOTIFICATION = 'HIDE_CONNECT_NOTIFICATION';
export const SHOW_ERROR_NOTIFICATION = 'SHOW_ERROR_NOTIFICATION';
export const HIDE_ERROR_NOTIFICATION = 'HIDE_ERROR_NOTIFICATION';
export const SET_EMAIL_READONLY = 'SET_EMAIL_READONLY';
export const UNSET_EMAIL_READONLY = 'UNSET_EMAIL_READONLY';
export const SET_EMBEDDED = 'SET_EMBEDDED';
export const ENABLE_IMAGE_UPLOAD = 'ENABLE_IMAGE_UPLOAD';
export const DISABLE_IMAGE_UPLOAD = 'DISABLE_IMAGE_UPLOAD';
export const SHOW_CHANNEL_PAGE = 'SHOW_CHANNEL_PAGE';
export const HIDE_CHANNEL_PAGE = 'HIDE_CHANNEL_PAGE';
export const SET_INTRO_HEIGHT = 'SET_INTRO_HEIGHT';
export const DISABLE_ANIMATION = 'DISABLE_ANIMATION';
export const SET_FETCHING_MORE_MESSAGES = 'SET_FETCHING_MORE_MESSAGES';
export const SET_SHOULD_SCROLL_TO_BOTTOM = 'SET_SHOULD_SCROLL_TO_BOTTOM';
export const ADD_TYPING_EVENT = 'ADD_TYPING_EVENT';
export const REMOVE_TYPING_EVENT = 'REMOVE_TYPING_EVENTS';
export const CLEAN_TYPING_EVENTS = 'CLEAN_TYPING_EVENTS';
export const UPDATE_WIDGET_SIZE = 'UPDATE_WIDGET_SIZE';
export const SET_INITIALIZATION_STATE = 'SET_INITIALIZATION_STATE';
export const SET_USER_IS_TYPING = 'SET_USER_IS_TYPING';
export const SET_CONNECTION_STATE = 'SET_CONNECTION_STATE';
export const SET_BLOCK_CHAT_INPUT = 'SET_BLOCK_CHAT_INPUT';
export const SET_ACTIVE_CONVERSATION_ID = 'SET_ACTIVE_CONVERSATION_ID';
